import { Component, ElementRef, Injector, Input, Optional, ViewChild } from '@angular/core';
import { ClienteUnicoServiceProxy, OrderDto, OrderDtoListResultDto, OrderItemDto, OrdersServiceProxy, PetDto } from '../services/service-proxy/service-proxies';
import { MatInput } from '@angular/material/input';
import { AppService, OrderStatus } from '../services/app.service';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-pet-form',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent {

    isLoading = false;
    order? : OrderDto;
    orderStatus! : OrderStatus;

  constructor(public appService : AppService, 
              private route: ActivatedRoute,
              private orderService: OrdersServiceProxy) {

              /*this.route.paramMap.subscribe(params => {
                    this.orderId = params.get('id')!;
              });*/

  }

  ngOnInit() {

    this.order = this.appService.getOrder();
    this.orderStatus = this.appService.convertirLogisticStatus(this.order!);
  }


  getImageDefault(){
    return '../assets/images/image-product-no-available.png';
  }

  loadErrorImage(event : Event){
    (event.target as HTMLImageElement).src = this.getImageDefault();
  }

  getTotalItem(item : OrderItemDto){
    let total = item.quantity * item.grossAmount;
    total = parseFloat(total.toFixed(2));
    return total;
  }

  getDiscountOrder() {
    if(this.order) {
      if(this.order.discount !== 0) 
        return this.order.discount < 0 ? this.order.discount * -1 : this.order.discount;
  
      if(this.order.grossAmount && this.order.netAmount)
        return this.order.grossAmount - this.order.netAmount;
    }

    return 0;
  }

  getTotalOrder( ){

    var total = 0;

    this.order?.orderItems?.forEach( item => {
      total = total + (item.quantity * item.grossAmount);
    });
    return total;
  }

}